/* eslint-disable import/prefer-default-export */
import * as lc from '../../../../utils/lodashCustom';

export function restructureUserReferralModel(state, data) {
  return {
    id: lc.get(data, 'id'),
    level: lc.get(data, 'level'),
    money: lc.get(data, 'money'),
    userId: lc.get(data, 'user_id'),
    referralId: lc.get(data, 'referral_id'),
    regAt: lc.get(data, 'reg_at'),
    referralUserName: lc.get(data, 'referral.username')
  };
}

export function restructureUserReferralTotalModel(state, data) {
  return {
    countReferral: lc.get(data, 'count_referral'),
    sumMoney: lc.get(data, 'sum_money')
  };
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/userReferral/services/restructuring/index.js